module.exports = __webpack_public_path__ + "img/pig-variant-outline.ef0e84fd.svg";